// extracted by mini-css-extract-plugin
export default {"form":"UpdateColumnForm_form__sv02s","fields":"UpdateColumnForm_fields__ctE2r"};